import './style.css';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import clsx from 'clsx';
import styles from './styles.module.scss';
import { Rudderstack } from '../../analytics/rudderstack/events';

let timeoutPromise = null;

function LinkList({ menu, misc }) {
  if (Array.isArray(menu)) {
    const {
      handleClickDropdown,
      handleMouseOutDropdown,
      activeUrl,
      openedDropdown,
    } = misc;

    return (
      <ul className="linklist_ul">
        {menu.map((item, i) => {
          const {
            name,
            link,
            icon,
            hasNotifications = false,
            dropdown = false,
            externalLink = false,
            subLinks,
            attrs,
          } = item;

          const trackNavbarItemClick = () => {
            Rudderstack.event('fp/base/menu_item_clicked', {
              linkTo: link,
            });
          };

          if (name) {
            const liContent = (
              <>
                {!!icon && <span className="icon">{icon}</span>}
                {!!name && <span className="nav-label">{name}</span>}
              </>
            );
            return (
              <li
                key={`${name}-${i}`}
                className={clsx(
                  {
                    active: activeUrl === link,
                    'dropdown-wrapper': dropdown,
                    [styles.hasNotifications]: hasNotifications,
                  },
                  'py-0',
                )}
                onClick={() => {
                  if (
                    dropdown &&
                    Array.isArray(subLinks) &&
                    openedDropdown.open !== name &&
                    openedDropdown.opening !== name
                  )
                    handleClickDropdown(name);
                }}
                onMouseOver={() => {
                  if (
                    dropdown &&
                    Array.isArray(subLinks) &&
                    openedDropdown.open !== name &&
                    openedDropdown.opening !== name
                  )
                    handleClickDropdown(name);
                }}
                onMouseLeave={() => {
                  if (
                    dropdown &&
                    Array.isArray(subLinks) &&
                    (openedDropdown.open === name ||
                      openedDropdown.opening === name)
                  )
                    handleMouseOutDropdown(name);
                }}
              >
                {link ? (
                  !externalLink ? (
                    <Link
                      {...attrs}
                      className="text-decoration-none text-dark pl-0 d-flex py-2 align-items-center"
                      to={link}
                      onClick={trackNavbarItemClick}
                    >
                      {liContent}
                    </Link>
                  ) : (
                    <a
                      {...attrs}
                      className="text-decoration-none text-dark pl-0 d-flex py-2 align-items-center"
                      href={link}
                      onClick={trackNavbarItemClick}
                    >
                      {liContent}
                    </a>
                  )
                ) : (
                  <div
                    {...attrs}
                    className="text-dark pl-0 dropdown py-2 d-flex py-2 align-items-center"
                  >
                    {liContent}
                  </div>
                )}

                {Array.isArray(subLinks) && !!dropdown && (
                  <div
                    className={`dropdown-ul ${
                      openedDropdown.open === name ? 'open' : ''
                    }${openedDropdown.closing === name ? 'closing' : ''}`}
                  >
                    <LinkList menu={subLinks} misc={misc} />
                  </div>
                )}
              </li>
            );
          }

          return null;
        })}
      </ul>
    );
  }
  console.error(
    'Not receiving an array as props for SidebarDropdown or childrens dropdowns',
  );
  return null;
}

const SidebarDropdown = props => {
  const { menu, activeUrl } = props;
  const [openedDropdown, setOpenedDropdown] = useState({
    open: undefined,
    opening: undefined,
    closing: undefined,
  });

  useEffect(() => {
    const { opening, closing } = openedDropdown;
    if (opening || closing) {
      if (timeoutPromise) clearTimeout(timeoutPromise);
      timeoutPromise = setTimeout(() => {
        timeoutPromise = null;
        setOpenedDropdown({
          open: opening,
          closing: undefined,
          opening: undefined,
        });
      }, 900);
    }
  }, [openedDropdown]);

  const handleClickDropdown = name => {
    const { open } = openedDropdown;
    const newOpeneds = {
      opening: name,
      closing: open,
      open: undefined,
    };
    setOpenedDropdown(newOpeneds);
  };

  const handleMouseOutDropdown = name => {
    const { open, opening } = openedDropdown;
    if (open === name || opening === name)
      setOpenedDropdown({
        open: undefined,
        opening: undefined,
        closing: name,
      });
  };

  return (
    <LinkList
      menu={menu}
      misc={{
        handleClickDropdown,
        handleMouseOutDropdown,
        activeUrl,
        openedDropdown,
      }}
    />
  );
};

export default SidebarDropdown;
